import axios, { AxiosRequestConfig } from 'axios';
import { default as config, NONE } from '../constants/constants';
import {
  DocumentSortOptionsEnum,
  DocumentSortOrderEnum,
  DocumentSortValueEnum
} from '../features/documents/types/types';

// Fetch podcast documents
export async function fetchDocuments(
  token: string,
  feedUrl: string,
  podcastId: string,
  documentsSearchValue: string,
  page: number,
  pageSize: number,
  season: number | string,
  documentSortOption: DocumentSortOptionsEnum = DocumentSortOptionsEnum.DEFAULT,
  documentSortValue?: DocumentSortValueEnum,
  documentSortOrder?: DocumentSortOrderEnum,
  forceReload?: boolean
) {
  const searchValue: string = encodeURIComponent(
    documentsSearchValue.trim().toLowerCase()
  );
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes/search`,
    params: {
      feedUrl: feedUrl,
      podcastId: podcastId,
      season: season !== NONE ? season : undefined,
      page: page,
      pageSize: pageSize,
      search: searchValue,
      order:
        documentSortOption !== DocumentSortOptionsEnum.DEFAULT
          ? documentSortValue
          : undefined,
      sort:
        documentSortOption !== DocumentSortOptionsEnum.DEFAULT
          ? documentSortOrder
          : undefined,
      forceReload: forceReload
    }
  };

  const response = await axios(options);
  return response;
}
